import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import MainNews from './component/main-news';
import MainSystem from './component/main-system';
import { HeaderComponent, FooterComponent, ExpectDialog, VideoPlayerDialog, LoadingDialog } from '../../shared-component';
import AppTool from '@/apps/@utils/app-tool';

const DEV_COUNTRY = {
  Central: [1, 2, 3, 4],
  North: [5, 6, 7, 8, 9],
  East: [10, 11, 12, 13],
  West: [14, 15, 16, 17],
  South: [18, 19, 20, 21],
  Other: [22, 23, 24, 25, 26],
};

const DEV_COUNTRY_DESCRIPT = {
  Central: 'country-central',
  North: 'country-north',
  East: 'country-east',
  West: 'country-west',
  South: 'country-south',
  Other: '',
};

const Main = () => {
  const [avatarList, setAvatarList] = useState(DEV_COUNTRY.Central);
  const [isPhone, setIsPhone] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(DEV_COUNTRY_DESCRIPT.Central);
  const newsPcTitleRef = useRef(null);
  const newsPhoneTitleRef = useRef(null);
  const wordPcTitleRef = useRef(null);
  const wordPhoneTextRef = useRef(null);
  const wordPcTextRef = useRef(null);
  const characterTextRef = useRef(null);
  const systemTitleRef = useRef(null);
  const welcomeTextRef = useRef(null);
  const welcomePhoneTextRef = useRef(null);
  const homeRef = useRef(null);

  const navigate = useNavigate()
  const handleChangeCountry = (country) => {
    setAvatarList(country)
    console.log(country);
  }
  const countryTitle = (country) => {
    setSelectedCountry(country);
    console.log(country);
  }

  const handleScroll = () => {
    console.log('scroll');
    if (newsPcTitleRef.current) {
      const { top } = newsPcTitleRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        newsPcTitleRef.current.classList.add('cTitleActive');
      }
    }
    if (newsPhoneTitleRef.current) {
      const { top } = newsPhoneTitleRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        newsPhoneTitleRef.current.classList.add('cTitleActive');
      }
    }

    if (wordPcTitleRef.current) {
      const { top } = wordPcTitleRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        wordPcTitleRef.current.classList.add('cTitleActive');
      }

    }

    if (wordPhoneTextRef.current) {
      const { top } = wordPhoneTextRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        wordPhoneTextRef.current.classList.add('cTitleActive');
      }
    }

    if (wordPcTextRef.current) {
      const { top } = wordPcTextRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        wordPcTextRef.current.classList.add('cTitleActive');
      }
    }

    if (characterTextRef.current) {
      const { top } = characterTextRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        characterTextRef.current.classList.add('cTitleActive');
      }
    }

    if (systemTitleRef.current) {
      const { top } = systemTitleRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        systemTitleRef.current.classList.add('cTitleActive');
      }
    }

    if (welcomeTextRef.current) {
      const { top } = welcomeTextRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        welcomeTextRef.current.classList.add('cTitleActive');
      }
    }

    if (welcomePhoneTextRef.current) {
      const { top } = welcomePhoneTextRef.current.getBoundingClientRect();
      const triggerHeight = window.innerHeight - window.innerHeight * 0.1;
      if (top <= triggerHeight) {
        welcomePhoneTextRef.current.classList.add('cTitleActive');
      }
    }
  };

  useEffect(() => {
    //AppTool.openLoadingDialog('.cLoadingDialog');
    setTimeout(() => { AppTool.closeLoadingDialog('.cLoadingDialog') }, 2000);

    console.log('ExamplePage mounted');
    setIsPhone(window.innerWidth < 1040);
    window.addEventListener('resize', () => {
      setIsPhone(window.innerWidth < 1040);
    });
  }, []);

  useEffect(() => {
    if (homeRef) {
      homeRef.current.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => {
      if (homeRef && homeRef.current) {
        homeRef.current.removeEventListener('scroll', handleScroll);
      }
    };
  }, [homeRef]);

  return (
    <div className="cMainPage">
      <ExpectDialog />
      <VideoPlayerDialog />
      <HeaderComponent />
      <LoadingDialog />
      <div className="cHome" ref={homeRef}>
        <div className="cMainBox">
          <img className="cBgLayer1 cPc" src={window.assetUrl('/images/home/main-bg01.png')} alt="" />
          <img className="cBgLayer2 cPc" src={window.assetUrl('/images/home/main-bg02.png')} alt="" />
          <img className="cDownBtn cPc" src={window.assetUrl('/images/home/down.png')} alt="" />
          <div className="cLogo cPc">
            <img src={window.assetUrl('/images/home/logo.png')} alt="logo section" />
          </div>
          <img className='cPhoneBg cPhone' src={window.assetUrl('/images/home/phone-bg.png')} />
          <div className="cAdvertisement">
            <img className='cBg' src={window.assetUrl('/images/home/fog-bg.png')} />
            <div className='cContent'>

              <div className="cVideo" onClick={() => { AppTool.openDialog(".cVideoPlayerDialog") }}>
                <img src={window.assetUrl('/images/home/index-right-ad-ad.png')} alt="index rightAD section" />
                <div className="cPlayButton cScaleAnimation">
                  <img src={window.assetUrl('/images/home/index-right-ad-play-btn.png')} />
                </div>
              </div>
              <div className="cLeftAD">
                <div className="cDescript">
                  <img src={window.assetUrl('/images/home/descript.png')} />
                </div>
                <div className="cRightADBtn">
                  <img className="cMediaItem" src={window.assetUrl('/images/footer/app-store.png')} onClick={() => { window.open("https://apps.apple.com/tw/app/%E9%AD%94%E6%B3%95%E4%BD%BF%E7%9A%84%E7%B4%84%E5%AE%9A/id6479690741") }} />
                  <img className="cMediaItem" src={window.assetUrl('/images/footer/google-play.png')} onClick={() => { window.open("https://play.google.com/store/apps/details?id=com.isweety.mht") }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="cNewBox">
          <MainNews newsPcTitleRef={newsPcTitleRef} newsPhoneTitleRef={newsPhoneTitleRef} />
        </div>
        <div className="cWorld">
          <img className="cWorldBG" src={window.assetUrl('/images/world/pc-world-bg.png')} />
          <img className="cPhoneWorldBG" src={window.assetUrl('/images/world/phone-pc-world-bg.png')} />
          <img className="cWorldTile cTitleInit" ref={wordPcTitleRef} src={window.assetUrl('/images/world/pc-index-title-world.png')} />
          <img className="cWorldText cTitleInit" ref={wordPcTextRef} src={window.assetUrl('/images/world/pc-world-text.png')} />
          <img className="cPhoneWorldText cTitleInit" ref={wordPhoneTextRef} src={window.assetUrl('/images/world/phone-pc-world-text.png')} />
          <img className="cDownBtn" src={window.assetUrl('/images/home/down.png')} alt="" />
        </div>
        <div className="cCharacter">
          <img className="cBG" src={window.assetUrl('/images/character/pc-character-bg.png')} />
          <img className="cPhoneBG" src={window.assetUrl('/images/character/phone-character-bg.png')} />
          <img className="cCircle1" src={window.assetUrl('/images/circle.png')} alt="" />
          <img className="cCircle2" src={window.assetUrl('/images/circle.png')} alt="" />

          <div className='cContentBox'>
            <img className="cTitle cTitleInit" ref={characterTextRef} src={window.assetUrl('/images/character/pc-index-title-character.png')} alt="" />
            <div className='cCountryBox'>
              <img className={`cCountry ${selectedCountry == DEV_COUNTRY_DESCRIPT.Central ? 'cSelect' : ''}`} src={window.assetUrl('/images/character/logo-central.png')} alt="" onClick={() => { handleChangeCountry(DEV_COUNTRY.Central); countryTitle(DEV_COUNTRY_DESCRIPT.Central) }} />
              <img className={`cCountry ${selectedCountry == DEV_COUNTRY_DESCRIPT.North ? 'cSelect' : ''}`} src={window.assetUrl('/images/character/logo-north.png')} alt="" onClick={() => { handleChangeCountry(DEV_COUNTRY.North); countryTitle(DEV_COUNTRY_DESCRIPT.North) }} />
              <img className={`cCountry ${selectedCountry == DEV_COUNTRY_DESCRIPT.East ? 'cSelect' : ''}`} src={window.assetUrl('/images/character/logo-east.png')} alt="" onClick={() => { handleChangeCountry(DEV_COUNTRY.East); countryTitle(DEV_COUNTRY_DESCRIPT.East) }} />
              <img className={`cCountry ${selectedCountry == DEV_COUNTRY_DESCRIPT.West ? 'cSelect' : ''}`} src={window.assetUrl('/images/character/logo-west.png')} alt="" onClick={() => { handleChangeCountry(DEV_COUNTRY.West); countryTitle(DEV_COUNTRY_DESCRIPT.West) }} />
              <img className={`cCountry ${selectedCountry == DEV_COUNTRY_DESCRIPT.South ? 'cSelect' : ''}`} src={window.assetUrl('/images/character/logo-south.png')} alt="" onClick={() => { handleChangeCountry(DEV_COUNTRY.South); countryTitle(DEV_COUNTRY_DESCRIPT.South) }} />
              <img className={`cCountry ${selectedCountry == DEV_COUNTRY_DESCRIPT.Other ? 'cSelect' : ''}`} src={window.assetUrl('/images/character/logo-other.png')} alt="" onClick={() => { handleChangeCountry(DEV_COUNTRY.Other); countryTitle(DEV_COUNTRY_DESCRIPT.Other) }} />
            </div>
            <div className='cDescription' style={{ display: selectedCountry === DEV_COUNTRY_DESCRIPT.Other ? 'none' : isPhone ? 'none' : 'block' }}>
              <img src={window.assetUrl(`/images/character/pc-${selectedCountry}.png`)} alt="" />
            </div>
            <div className='cDescription_Phone' style={{ display: selectedCountry === DEV_COUNTRY_DESCRIPT.Other ? 'none' : isPhone ? 'block' : 'none' }}>
              <img src={window.assetUrl(`/images/character/phone-${selectedCountry}.png`)} alt="" />
            </div>
            <div className="cAvatarBox">
              {avatarList.map((row, index) => (
                <div className='cAvatar' key={index}>
                  <img src={window.assetUrl(`/images/character/${row}.png`)} onClick={() => { navigate(`/avatar?index=${row}`) }} />
                </div>
              ))}
            </div>
            <img className="cDownBtn" src={window.assetUrl('/images/home/down.png')} alt="" />
          </div>
        </div>
        <MainSystem systemTitleRef={systemTitleRef} />
        <div className='cWelcomeBox'>
          <img className="cBg" src={window.assetUrl('/images/welcome/bg.jpg')} alt="" />
          <img className="cPhoneBg" src={window.assetUrl('/images/welcome/phone-bg.jpg')} alt="" />
          <img className="cWelcome cTitleInit" ref={welcomeTextRef} src={window.assetUrl('/images/welcome/welcome.png')} alt="" />
          <img className="cPhoneWelcome cTitleInit" ref={welcomePhoneTextRef} src={window.assetUrl('/images/welcome/phone-welcome.png')} alt="" />
          <div className='cContentBox' >
            <div className='cItemBox' onClick={() => { window.open("https://www.facebook.com/mahoyakuzh/") }}>
              <img className="cItem cOff" src={window.assetUrl(`/images/welcome/fb-off.png`)} />
              <img className="cItem cOn" src={window.assetUrl(`/images/welcome/fb-on.png`)} />
            </div>
            <div className='cItemBox' onClick={() => { window.open("https://www.instagram.com/isweetyig/") }}>
              <img className="cItem cOff" src={window.assetUrl(`/images/welcome/ig-off.png`)} />
              <img className="cItem cOn" src={window.assetUrl(`/images/welcome/ig-on.png`)} />
            </div>
            <div className='cItemBox' onClick={() => { window.open("https://www.plurk.com/mahoyakuzh") }}>
              <img className="cItem cOff" src={window.assetUrl(`/images/welcome/plurk-off.png`)} />
              <img className="cItem cOn" src={window.assetUrl(`/images/welcome/plurk-on.png`)} />
            </div>
            <div className='cItemBox' onClick={() => { window.open("https://page.line.me/ofn9823a?openQrModal=true") }}>
              <img className="cItem cOff" src={window.assetUrl(`/images/welcome/line-off.png`)} />
              <img className="cItem cOn" src={window.assetUrl(`/images/welcome/line-on.png`)} />
            </div>
          </div>
        </div>
        <FooterComponent />
      </div>

    </div>
  );
};

export default Main;
